// const axios = require('axios')
// import React from "react"
// import defaultConfig from '../config/defaultConfig'
// // import encrypted from '../helper'

// class Http extends React.Component  {
//     constructor(props) {
//         super(props)
//         this.http = this.http.bind(this)
//     }
    
//     http(method, endpoint, params, data = {}, headerData = '') {
//         const headers = {}
//         headers['Access-Control-Allow-Headers'] = '*'
//         headers['Authorization'] = this.getToken()
//         const getUserData = JSON.parse(localStorage.getItem('userData'))
//         if (getUserData && getUserData.eid) {
//             headers['usedwhich'] = getUserData.eid.split('-')[0]
//         }
//         if (headerData) {
//             for (const key in headerData) {
//                 headers[key] = headerData[key]
//             }
//         }
//         return axios({
//             method,
//             url: `${defaultConfig.GAVL_BACKEND_URL}/${endpoint}`,
//             headers,
//             params,
//             data
//           })
//             .then(response => response.data)
//     }
//     getToken() {
//         return localStorage.getItem('accessToken')
//       }
// }
// export default Http
// const axios = require("axios")
// import React from "react"
// import defaultConfig from "../config/defaultConfig"

// class Http extends React.Component {
//   constructor(props) {
//     super(props)

//     this.http = this.http.bind(this)
//     this.logoutUser = this.logoutUser.bind(this)
//   }

//   logoutUser() {
//     // Avoid looping after redirect
//     if (window.location.pathname.includes("/login")) {
//       return
//     }

//     localStorage.removeItem("accessToken")
//     localStorage.removeItem("userData")
//     localStorage.removeItem("dbname")
//     localStorage.removeItem("tokenExpiry")

//     window.location.replace("/login")
//   }

//   http(method, endpoint, params = {}, data = {}, headerData = {}) {
//     const headers = {}

//     const token = this.getToken()

//     // Required for Laravel Sanctum
//     if (token) {
//       headers.Authorization = `Bearer ${token}`
//     }

//     const userData = JSON.parse(localStorage.getItem("userData") || "null")

//     if (userData?.eid) {
//       headers.usedwhich = userData.eid.split("-")[0]
//     }

//     if (headerData) {
//       Object.assign(headers, headerData)
//     }

//     return axios({
//       method,
//       url: `${defaultConfig.GAVL_BACKEND_URL}/${endpoint}`,
//       headers,
//       params,
//       data
//     })
//       .then((response) => response.data)
//       .catch((error) => {
//         const status = error.response?.status
//         const apiCode = error.response?.data?.code

//         // Token expired / employee logged in from another device
//         if (status === 401 || apiCode === 401) {
//           this.logoutUser()
//         }

//         return Promise.reject(error)
//       })
//   }

//   getToken() {
//     return localStorage.getItem("accessToken")
//   }
// }

// export default Http

const axios = require("axios")
import React from "react"
import defaultConfig from "../config/defaultConfig"
import { getMachineId } from "../../utility/machineID"
import { applyTtl, stop as stopSessionMonitor } from "../../utility/sessionMonitor"

export const SESSION_MESSAGES = {
  SESSION_TAKEN_OVER: "You were signed out because your account was used on another device.",
  SESSION_EXPIRED: "Your session expired. Please sign in again.",
  DEVICE_MISMATCH: "This session belongs to a different device.",
  IP_CHANGED: "Your network changed. Please sign in again.",
  SESSION_REVOKED: "This session was ended.",
  SESSION_UNKNOWN: "Please sign in again."
}

class Http extends React.Component {
  constructor(props) {
    super(props)
    this.http = this.http.bind(this)
    this.logoutUser = this.logoutUser.bind(this)
  }

  logoutUser(reason = null) {
    // Avoid looping after redirect
    if (window.location.pathname.includes("/login")) {
      return
    }

    stopSessionMonitor()

    // sessionStorage, not localStorage: window.location.replace() is a hard
    // navigation, so the reason has to survive a full page load. Cleared by
    // the login page after it reads it once.
    if (reason) {
      sessionStorage.setItem(
        "logoutReason",
        SESSION_MESSAGES[reason] || SESSION_MESSAGES.SESSION_UNKNOWN
      )
    }

    localStorage.removeItem("accessToken")
    localStorage.removeItem("userData")
    localStorage.removeItem("dbname")
    localStorage.removeItem("tokenExpiry")
    // NOTE: "machineId" is deliberately kept — rotating it on every logout
    // would break device tracking on the next login.

    window.location.replace("/login")
  }

  http(method, endpoint, params = {}, data = {}, headerData = {}) {
    const headers = {}
    const token = this.getToken()

    // Required for Laravel Sanctum
    if (token) {
      headers.Authorization = `Bearer ${token}`
    }

    // Must match the value recorded at login or the guard returns
    // DEVICE_MISMATCH and kills the session.
    headers["X-Machine-Id"] = getMachineId()

    const userData = JSON.parse(localStorage.getItem("userData") || "null")
    if (userData?.eid) {
      headers.usedwhich = userData.eid.split("-")[0]
    }

    if (headerData) {
      Object.assign(headers, headerData)
    }

    return axios({
      method,
      url: `${defaultConfig.GAVL_BACKEND_URL}/${endpoint}`,
      headers,
      params,
      data
    })
      .then((response) => {
        // Every authenticated response carries the remaining TTL. If these
        // are undefined in the browser, the API's CORS exposed_headers is not
        // configured — see the backend note.
        const ttl = response.headers["x-session-ttl"]
        const warn = response.headers["x-session-warn-at"]

        if (ttl !== undefined) {
          applyTtl(Number(ttl), warn !== undefined ? Number(warn) : undefined)
        }

        return response.data
      })
      .catch((error) => {
        const status = error.response?.status
        const body = error.response?.data
        const apiCode = body?.code

        // Token expired / employee logged in from another device.
        // The guard now sends a `reason` alongside the 401 so the login page
        // can explain what happened instead of silently bouncing them.
        if (status === 401 || apiCode === 401) {
          this.logoutUser(body?.reason || null)
        }

        return Promise.reject(error)
      })
  }

  getToken() {
    return localStorage.getItem("accessToken")
  }

  // ---- session endpoints -------------------------------------------------

  heartbeat() {
    return this.http("get", "session/heartbeat", {}, {}, { "X-Session-No-Extend": "1" })
  }

  extendSession() {
    return this.http("post", "session/extend")
  }

  sessionHistory() {
    return this.http("get", "session/history")
  }

  logout() {
    return this.http("post", "logout")
  }
}

export default Http